/**
 * @module cercaliagl/view/VZoom
 */

import $ from 'jquery';
import { MDCRipple } from '@material/ripple';
import BaseView from './BaseView';

const ClassName = {
  GPS: 'gps',
  D3: 'd3',
  ROTATE: 'rotate',
  ZOOM: 'zoom',
  ZOOM_IN: 'zoomin',
  ZOOM_OUT: 'zoomout',
};

/**
 * @enum {string}
 */
export const EventType = {
  ZOOM_IN: 'zoomin',
  ZOOM_OUT: 'zoomout',
  GPS: 'gps',
  D3: 'd3',
  ROTATE: 'rotate',
  ROTATE_LEFT: 'rotate_left',
  ROTATE_RIGHT: 'rotate_right',
};

function createFabButton(iconSuffix, className) {
  return `
    <button type="button" class="mdc-fab mdc-fab--touch ${className}">
      <div class="mdc-fab__ripple"></div>
      <span class="icon-${iconSuffix} mdc-fab__icon"></span>
      <div class="mdc-fab__touch"></div>
    </button>
  `;
}

/**
 * @return {JQuery} Create view
 */
function createView() {
  const html = `
    <div class="mdc-touch-target-wrapper">
      <div class="rotate">
        <div class="compass"></div>
        <div class="arrow left"></div>
        <div class="arrow right"></div>
      </div>
      <button type="button" class="mdc-fab mdc-fab--touch ${ClassName.D3}">
        <div class="mdc-fab__ripple"></div>
        <span class="mdc-fab__icon mode">3D</span>
        <div class="mdc-fab__touch"></div>
      </button>
      ${createFabButton('gps', ClassName.GPS)}
      <div class="${ClassName.ZOOM}">
        ${createFabButton('add', ClassName.ZOOM_IN)}
        ${createFabButton('remove', ClassName.ZOOM_OUT)}
      </div>
    </div>
  `;
  return $(html);
}

/**
 * @classdesc
 */
class VZoom extends BaseView {
  /**
   * @constructor
   */
  constructor() {
    const jqElement = createView();

    super(jqElement);

    this.initialize_();
  }

  /**
   * @private
   */
  initialize_() {
    if (this.jqElement_ === null) {
      return;
    }
    const jqMdcFab = this.jqElement_.find('.mdc-fab');
    if (!jqMdcFab) {
      return;
    }
    jqMdcFab.each((index, elem) => new MDCRipple(elem));
    this.jqElement_.find(`.${ClassName.ZOOM_IN}`).click(() => this.emit(EventType.ZOOM_IN, {}));
    this.jqElement_.find(`.${ClassName.ZOOM_OUT}`).click(() => this.emit(EventType.ZOOM_OUT, {}));
    this.jqElement_.find(`.${ClassName.GPS}`).click(() => this.emit(EventType.GPS, {}));
    this.jqElement_.find(`.${ClassName.D3}`).click(() => this.emit(EventType.D3, {}));
    this.jqElement_.find('.compass').click(() => this.emit(EventType.ROTATE, {}));
    this.jqElement_.find('.rotate .left').click(() => this.emit(EventType.ROTATE_LEFT, {}));
    this.jqElement_.find('.rotate .right').click(() => this.emit(EventType.ROTATE_RIGHT, {}));
  }

  /**
   * @param {number} deg Degrees
   */
  rotateCompass(deg) {
    this.jqElement_.find('.compass').css({ transform: `rotate(${deg}deg)`, transition: '0.5' });
  }

  /**
   * @param {string} className ClassName
   * @override
   */
  show(className) {
    this.jqElement_.find(`.${className}`).show();
  }

  /**
   * @param {string} className ClassName
   * @override
   */
  hide(className) {
    this.jqElement_.find(`.${className}`).hide();
  }

  /**
   * @param {boolean} enable Enable or false
   */
  set3D(enable) {
    this.jqElement_.find(`.${ClassName.D3} .mode`).text(enable ? '3D' : '2D');
  }
}

export default VZoom;
